export class HrPerSuspensionKey {
    private static readonly keyPrefix = 'hrPerSuspension';
    public static title = `${HrPerSuspensionKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerSuspensionKey.keyPrefix}.pageHeader`;
    public static suspensionType = `${HrPerSuspensionKey.keyPrefix}.suspensionType`;
    public static returnStatus = `${HrPerSuspensionKey.keyPrefix}.returnStatus`;
    public static serviceStatus = `${HrPerSuspensionKey.keyPrefix}.serviceStatus`;
    public static matterCode = `${HrPerSuspensionKey.keyPrefix}.matterCode`;
    public static matterText = `${HrPerSuspensionKey.keyPrefix}.matterText`;
    public static suspensionSalaryStartdate = `${HrPerSuspensionKey.keyPrefix}.suspensionSalaryStartdate`;
    public static suspensionSalaryEnddate = `${HrPerSuspensionKey.keyPrefix}.suspensionSalaryEnddate`;
    public static dismissalSalaryStartDate = `${HrPerSuspensionKey.keyPrefix}.dismissalSalaryStartDate`;
    public static dismissalSalaryEndDate = `${HrPerSuspensionKey.keyPrefix}.dismissalSalaryEndDate`;
    public static startSuspensionDate = `${HrPerSuspensionKey.keyPrefix}.startSuspensionDate`;
    public static dismissalDate = `${HrPerSuspensionKey.keyPrefix}.dismissalDate`;
    public static requestReinstatementDate = `${HrPerSuspensionKey.keyPrefix}.requestReinstatementDate`;
    public static reinStatementDate = `${HrPerSuspensionKey.keyPrefix}.reinStatementDate`;
    public static stateOfEmergencyEndDate = `${HrPerSuspensionKey.keyPrefix}.stateOfEmergencyEndDate`;
    public static returnOfSuspensionDate = `${HrPerSuspensionKey.keyPrefix}.returnOfSuspensionDate`;
    public static monthlyPaymentDate = `${HrPerSuspensionKey.keyPrefix}.monthlyPaymentDate`;
    public static firstPCardPageHeader = `${HrPerSuspensionKey.keyPrefix}.firstPCardPageHeader`;
    public static secondPCardPageHeader = `${HrPerSuspensionKey.keyPrefix}.secondPCardPageHeader`;
    public static sendApprove = `${HrPerSuspensionKey.keyPrefix}.sendApprove`;
    public static sendDraft = `${HrPerSuspensionKey.keyPrefix}.sendDraft`;
    public static operations = `${HrPerSuspensionKey.keyPrefix}.operations`;
    public static approve = `${HrPerSuspensionKey.keyPrefix}.approve`;
    public static bpmnChangeRequestMessage = `${HrPerSuspensionKey.keyPrefix}.bpmnChangeRequestMessage`;
}
